import {
  Button,
  Center,
  HStack,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  StackProps,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { Clock, UsersThree, Video } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import { Course } from "../../const/types";
import formatDuration from "../../lib/formatDuration";

interface Props extends StackProps {
  data: Course;
}

export default function CourseListItemDetail({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <HStack
        py={3}
        px={5}
        borderBottom={"1px solid var(--divider)"}
        _hover={{ bg: "var(--divider)" }}
        cursor={"pointer"}
        justify={"space-between"}
        onClick={onOpen}
      >
        <Text noOfLines={1}>{data.nama_course}</Text>
        <Tooltip label={`Total Bergabung ${data.people_joined}`}>
          <Center
            flexShrink={0}
            w={"40px"}
            h={"20px"}
            p={1}
            borderRadius={"full"}
            bg={"var(--divider2)"}
          >
            <Text opacity={0.6}>{data.people_joined}</Text>
          </Center>
        </Tooltip>
      </HStack>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>Course Detail</ModalHeader>

          <ModalBody>
            <Image
              src={`${process.env.REACT_APP_MEDIA_BASE_URL}${data.image}`}
              mb={4}
            />

            <Text fontWeight={600} fontSize={20} lineHeight={1.3} mb={2}>
              {data.nama_course}
            </Text>

            <Tooltip
              label={`Total durasi ${formatDuration(data.total_duration)}`}
            >
              <HStack w={"fit-content"}>
                <Icon as={Clock} fontSize={iconSize} />
                <Text>{formatDuration(data.total_duration)}</Text>
              </HStack>
            </Tooltip>

            <Tooltip label={`${data.people_joined} bergabung`}>
              <HStack w={"fit-content"}>
                <Icon as={UsersThree} fontSize={iconSize} />
                <Text>{data.people_joined}</Text>
              </HStack>
            </Tooltip>

            <Tooltip label={`${JSON.parse(data.silabus_order).length} video`}>
              <HStack w={"fit-content"} mb={4}>
                <Icon as={Video} fontSize={iconSize} />
                <Text>{JSON.parse(data.silabus_order).length}</Text>
              </HStack>
            </Tooltip>

            <Text opacity={0.6}>{data.description}</Text>
          </ModalBody>

          <ModalFooter>
            <Button w={"100%"} className="btn-solid clicky" onClick={onClose}>
              Ok
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
